import { getComposeStore } from 'owa-calendar-compose-store-manager';
import isDirty from './isDirty';
import { showUndoNotificationForCompose } from 'owa-calendar-compose-form-actions';

/**
 * Checks if the form is dirty and is Quick compose, then displays the undo notification
 */
export default function checkDirtyStateThenShowNotification() {
    const { event, originalEvent, openedForm } = getComposeStore();
    const isFormDirty = isDirty(event, originalEvent, false /*shouldIgnoreAttachments*/);

    // The compose form is dirty so we need to present the undo dialog and ensure we don't reset the store
    if (isFormDirty) {
        showUndoNotificationForCompose(openedForm);
    }
}
